import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

type BookSaveFullscreenLoadingProps = {
  open: boolean;
  /** Shown under the spinner (e.g. while uploading cover / page images then saving). */
  message?: string;
};

export default function BookSaveFullscreenLoading({
  open,
  message = 'Зураг оруулж, хадгалж байна…',
}: BookSaveFullscreenLoadingProps) {
  return (
    <Backdrop
      open={open}
      aria-busy={open}
      aria-live="polite"
      aria-label={open ? message : undefined}
      sx={(theme) => ({
        zIndex: theme.zIndex.modal + 2,
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backdropFilter: 'blur(6px)',
        backgroundColor: alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.88 : 0.92),
        color: 'text.primary',
      })}
    >
      <Stack alignItems="center" spacing={2}>
        <CircularProgress size={48} thickness={4} color="primary" aria-hidden />
        <Typography variant="body1" color="text.primary" textAlign="center" sx={{ maxWidth: 280 }}>
          {message}
        </Typography>
      </Stack>
    </Backdrop>
  );
}
